// extracted by mini-css-extract-plugin
module.exports = {"condition":"styles_condition__2p5ke","btn":"styles_btn__2qIaS"};